<template>
<el-card>
    <el-collapse accordion>
         <el-collapse-item title="Klaviyo" name="1">
      <button  v-if="actions.length === 0" class="btn btn-primary float-right" @click="getKlaviyoProfile">Get Klaviyo Data</button>
      <br />
      <br />
      <el-timeline v-if="actions.length > 0">
        <el-timeline-item v-for="(activity, index) in actions" :key="index" :color="getColor()">
          <strong v-html="getName(activity.relationships.metric.data.id)"></strong>
          - {{activity.type}}
          <br />
          {{activity.attributes.timestamp | moment('DD/MM/YY')}} -
          <small>{{activity.attributes.timestamp | moment("from", "now", true)}} ago</small>
        </el-timeline-item>
      </el-timeline>
      <hr>
      <!--
      <h6 class="card-title" v-if="Object.keys(profile).length > 0">Klaviyo Profile</h6>
      <ul v-if="Object.keys(profile).length > 0" style="list-style-type: none;padding:10px;">
        <li v-for="(k,v) in profile">
          <span>
            <strong>{{v}}: </strong>
            {{k}}
          </span>
        </li>
      </ul>
      -->
       </el-collapse-item>
        </el-collapse>
</el-card>
</template>
<script>
import api from "../api";

import TimeLine from "./TimeLine.vue";
import TimeLineItem from "./TimeLineItem.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";

export default {
  props: ["customer"],
  components: {
    TimeLine,
    TimeLineItem,
    VueEditor
  },
  data() {
    return {
      actions: [],
      profile: [],
      metrics: [],
    };
  },

  computed: {
    ...mapGetters(["getCustomer"]),
    users() {
      return this.$store.getters.getUsers;
    },

    user() {
      return this.$store.getters.getProfile;
    }
  },
  methods: {
    getActions() {
      console.log(this.customer.email);
      const actionsPromise = api.getActions(this.customer.email);

      Promise.resolve(actionsPromise).then(result => {
        console.log(result);
        this.actions = result.data.activity.map(g => {
          g.color = "#" + Math.floor(Math.random() * 16777215).toString(16);
          return g;
        });
      });
    },
    getMCProfile() {
      const profilePromise = api.getMailchimpProfile(this.customer.email);
      Promise.resolve(profilePromise).then(result => {
        for (let [key, value] of Object.entries(result.data.merge_fields)) {
          if (value === "") {
            delete result.data.merge_fields[key];
          }
          if (Object.keys(result.data.merge_fields).length > 0)
            this.profile = result.data.merge_fields;
          else this.profile = { profile: "empty, or not set" };
        }
      });
    },
    getKlaviyoProfile() {
    // GET DATA FROM KLAVIYO
    // const klaviyoApiKey = process.env.KLAVIYO_API_KEY;
    const getHeaders = {
    'content-type': 'application/json',
    };
    const encodedEmail = encodeURIComponent(this.customer.email);
    const getData = {
      // mode: 'no-cors',
      method: 'GET',
      headers: getHeaders
    };
    const pUrl = process.env.SERVER_URL+'/klaviyo/members/profile/'+this.customer.email;
    const mUrl = process.env.SERVER_URL+'/klaviyo/members/metrics/'+this.customer.email;
    const kUrl = process.env.SERVER_URL+'/klaviyo/members/'+this.customer.email;

    let mData;
    try {
      kData = fetch(mUrl, getData)
      .then(res => res.json())
      .then(json => this.metrics = json)
      // .then(json => this.actions = json)
      .catch(error => {
        // Return a network error and the text of the error
        return {
          statusCode: 500,
          body: JSON.stringify({error})
        }
      })
    } catch (e) {
      return {
        statusCode: 500,
        body: JSON.stringify({
          error: e.message
        })
      }
    }
    
    let kData;
    try {
      kData = fetch(kUrl, getData)
      .then(res => res.json())
      .then(json => this.actions = json)
      // .then(json => this.actions = json)
      .catch(error => {
        // Return a network error and the text of the error
        return {
          statusCode: 500,
          body: JSON.stringify({error})
        }
      })
    } catch (e) {
      return {
        statusCode: 500,
        body: JSON.stringify({
          error: e.message
        })
      }
    }

    let pData;
    try {
      kData = fetch(pUrl, getData)
      .then(res => res.json())
      .then(json => this.profile = json.attributes)
      // .then(json => this.actions = json)
      .catch(error => {
        // Return a network error and the text of the error
        return {
          statusCode: 500,
          body: JSON.stringify({error})
        }
      })
    } catch (e) {
      return {
        statusCode: 500,
        body: JSON.stringify({
          error: e.message
        })
      }
    }

    // console.log('Klaviyo data',kData);
    },
    getName(id){
      const name = this.metrics.find(m => m.id === id);
      return name.attributes.name
    },
    getColor(){
      return "#" + Math.floor(Math.random() * 16777215).toString(16);
    }
  },
  mounted() {
    // this.getProducts();
    //  this.initDepartures()
  },
  watch: {
    "$route.params.id": function(id) {
      this.customerID = id;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/Actions.vue